var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-base"},[_c(_vm.currentComponent,{tag:"component",staticClass:"modal-base__component",on:{"close-modal":_vm.closeModal}}),_c('div',{staticClass:"modal-base__backdrop"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }